import config from 'config';
import { rumService } from 'services/rum';
import {
  normalizeActivities,
  normalizeLegacyActivities,
} from 'utils/activities';
import { createAPIError } from 'utils/exceptions/apiError';

export type Activity = {
  id: string;
  translationKey: string;
  defaultValue: string;
  category: {
    id: string;
    translationKey: string;
    defaultValue: string;
  };
};

export type LegacyActivity = {
  id: string;
  activity_key: string;
  category_key: string;
};

export async function getActivities(): Promise<Activity[]> {
  const url = `${config.PARTNERS_SELF_SIGNUP_BFF_URL}/activities`;

  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw await createAPIError(response);
  }

  const result: Activity[] = await response.json();

  return result;
}

export function getActivitiesQueryOptions() {
  const loadLegacyActivities = async () => {
    const { default: legacyActivities } = await import(
      'assets/json/activities.json'
    );

    return normalizeLegacyActivities(legacyActivities);
  };

  return {
    queryKey: ['activities'],
    queryFn: async () => {
      try {
        const activities = await getActivities();
        return activities;
      } catch (error) {
        rumService.addError(
          new Error(
            `[getActivities] Error loading activities - fallback to local snapshot`,
            { cause: error },
          ),
        );
        return loadLegacyActivities();
      }
    },
    select: (data: Activity[]) => normalizeActivities(data),
    refetchOnMount: false,
  };
}
